import {
  ACCOUNTING_APP_ID,
  JOURNALS_APP_ID,
  POS_APP_ID,
  REPORTS_APP_ID,
  TAX_CALENDAR_APP_ID,
  isAnySlimBooksAppInstalled,
} from './installedAppPathScope';

export type DownloadablesVisibility = {
  showPosDownloads: boolean;
  showAccountingDownloads: boolean;
  showTaxDownloads: boolean;
  hasVisibleDownloads: boolean;
};

/**
 * Which downloadable groups apply for the company's installed apps.
 * Matches the Downloadables page empty-state rules.
 */
export function getDownloadablesVisibility(
  isAppInstalled: (appId: string) => boolean,
  appsReady: boolean,
): DownloadablesVisibility {
  if (!appsReady) {
    return {
      showPosDownloads: false,
      showAccountingDownloads: false,
      showTaxDownloads: false,
      hasVisibleDownloads: false,
    };
  }

  const showPosDownloads = isAppInstalled(POS_APP_ID);
  const showAccountingDownloads =
    isAppInstalled(ACCOUNTING_APP_ID) ||
    isAppInstalled(JOURNALS_APP_ID) ||
    isAppInstalled(REPORTS_APP_ID) ||
    isAnySlimBooksAppInstalled(isAppInstalled);
  const showTaxDownloads = isAppInstalled(TAX_CALENDAR_APP_ID);

  return {
    showPosDownloads,
    showAccountingDownloads,
    showTaxDownloads,
    hasVisibleDownloads:
      showPosDownloads || showAccountingDownloads || showTaxDownloads,
  };
}
